import PropTypes from "prop-types";
import React from "react";
import { connect, } from "react-redux";
import { firestoreConnect, } from "react-redux-firebase";
import { compose } from "redux";
import {
    Divider,
    Grid,
    Item,
} from "semantic-ui-react";
import RegionForm from "./RegionForm";
import Submission from "./Submission";
import Deadline from "./util/Deadline";
import regionComparator from "./util/regionComparator";
import whoami from "./selectors/whoami";

class SubmissionPane extends React.PureComponent {

    render() {
        const {
            context: ctx,
            createSubmission,
            me,
            submissions,
        } = this.props;
        let subCount = 0;
        const hasSubmissions = submissions && submissions.length > 0;
        return <div>
            {hasSubmissions && <Grid style={{
                maxHeight: "50vh",
                overflowY: "auto",
            }}>
                {submissions.map(s =>
                    <Submission key={s.id}
                                submission={s}
                                index={subCount++}
                                me={me}
                    />,
                )}
            </Grid>}
            {hasSubmissions && <Divider />}
            <Item.Group divided>
                {ctx.regions
                    .sort(regionComparator)
                    .map(r =>
                        <Item key={r.name}>
                            <Item.Content>
                                <Item.Header>
                                    {r.name}
                                    {" "}
                                    {r.when && <Deadline ts={r.when} />}
                                </Item.Header>
                                {(!r.when || r.when > Date.now())
                                && r.accept
                                && <Item.Description>
                                    <RegionForm region={r}
                                                context={ctx}
                                                createSubmission={data =>
                                                    createSubmission(r.name, data)}
                                    />
                                </Item.Description>}
                            </Item.Content>
                        </Item>,
                    )}
            </Item.Group>
        </div>;
    }
}

SubmissionPane.propTypes = {
    context: PropTypes.object.isRequired,
    createSubmission: PropTypes.func.isRequired,
};

export default compose(
    firestoreConnect(props => {
        const q = {
            collection: `contexts/${props.context.id}/submissions`,
            orderBy: [
                ["createdAt", "desc"],
            ],
        };
        return [q];
    }),
    connect(
        (state, props) => ({
            me: whoami(state),
            submissions: state.firestore.ordered[`contexts/${props.context.id}/submissions`],
        }),
    ),
)(SubmissionPane);



// WEBPACK FOOTER //
// ./src/SubmissionPane.js